import React, { useState, useContext} from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../AuthContext';
import s from '../styles/login.module.css'; 


function Login() {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { fetchCurrentUser, isLoggingOut } = useContext(AuthContext);



  
  const handleLogin = async (e) => {
    e.preventDefault(); // Предотвращаем отправку формы
    try {
      const response = await fetch('/api/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({login, password }),
      });

      if (!response.ok) {
        const data = await response.json();
        setError(data.error || 'Login failed');
        return;
      }

      // Если запрос успешен
      const data = await response.json();
      console.log('Login successful:', data);
          // 1) Сохраняем токен в localStorage
     if (data.token) {
       localStorage.setItem('user_token', data.token);
       // Можем также сохранить user_role, если нужно
       localStorage.setItem('user_role', data.user_role);
     }
      // Обновляем данные текущего пользователя
      isLoggingOut.current = false;
      await fetchCurrentUser();
      
      // Перенаправляем пользователя
      navigate('/dashboard');


    } catch (err) {
      setError('Error logging in');
    }
  };

  return (

      <div className={s.login_container}>
        <div className={s.login_form}>
          <form className={s.login_form_form} onSubmit={handleLogin}>
            <input
              type="login"
              placeholder="Логин"
              value={login}
              onChange={(e) => setLogin(e.target.value)}
              autoComplete="login"
              required
              className={s.login_form_input}
            />
            <input
              type="password"
              placeholder="Пароль"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              className={s.login_form_input}
            />
            <div className={s.link}>
              <Link
                to="https://t.me/fiveadspro_bot?start=resetpassword"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#7e7a7a' }}
              >
                Забыли пароль?
              </Link>
            </div>
            <button  className={s.login_form_button} type="submit">Войти</button>
            {error && <p className={s.login_form_p}>{error}</p>}
          </form>
        </div>
      </div>
  );
}

export default Login;
